import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListHubunganKeluarga } from "@/services/getData"

export default function MasterHubunganKeluargaPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listHubunganKeluarga"],
    queryFn: () => getListHubunganKeluarga(),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
